// extracted by mini-css-extract-plugin
export var deleteModal = "_fn-0";